import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, SvgIcon, Text } from 'Components/Base';

const EmptyStateWrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;
  margin-y: auto;
  height: 100vh;
  text-align: center;
  word-break: break-word;
  grid-row-gap: 16px;
  background-color: ${({ theme }) => theme.colors.backgroundNeutralLightgrey};
  color: ${({ theme }) => theme.colors.clear.clearGrayDark};
  padding: ${({ theme }) => `${theme.space[9]}px ${theme.space[7]}px ${theme.space[7]}px`};
`;

const EmptyState = ({ title, description, action }) => {
  return (
    <EmptyStateWrapper>
      <SvgIcon icon={SvgIcon.ICON_LIST.EMPTY_STATE_CLEAR_ICON} width={180} height={180} />
      <Text textStyle={'heading4'} lineHeight={1.6}>
        {title}
      </Text>
      <Text textStyle={'subtitle1'} lineHeight={1.6} fontWeight={400}>
        {description}
      </Text>
      {action && action}
    </EmptyStateWrapper>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
};

export default EmptyState;
